import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import RoboticsShell from "./RoboticsShell";
import { useAuth } from "../../lib/auth";

/**
 * Sign-in — Robotics UI on top of the shared STEAM `AuthProvider`. Student
 * never sees any STEAM branding. Backend endpoint is /api/auth/login,
 * invisible to the user.
 */
export default function RoboticsSignin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  async function onSubmit(e) {
    e.preventDefault();
    if (!email || !password) {
      setStatus({ state: "err", msg: "Email and password are required." });
      return;
    }
    setStatus({ state: "loading", msg: "" });
    try {
      await login(email, password);
      nav("/robotics/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Sign-in failed. Check your credentials.";
      setStatus({ state: "err", msg: String(detail) });
    }
  }

  return (
    <RoboticsShell>
      <section className="rbx-page" data-testid="rbx-page-signin" style={{ maxWidth: 480 }}>
        <span className="rbx-eyebrow">Session · Sign in</span>
        <h1 className="rbx-page__title" data-testid="rbx-signin-title">
          Back to the bench.
        </h1>
        <p className="rbx-page__lede">
          Sign in to pick up where you left off. New here?{" "}
          <Link to="/robotics/signup" style={{ color: "var(--rbx-gold)" }}>Create an account</Link>.
        </p>

        <form className="rbx-form" onSubmit={onSubmit} data-testid="rbx-signin-form">
          <div>
            <label className="rbx-label" htmlFor="rbx-signin-email">Email</label>
            <input id="rbx-signin-email" className="rbx-input" type="email" value={email}
                   onChange={(e) => setEmail(e.target.value)} data-testid="rbx-signin-email"
                   autoComplete="email"/>
          </div>
          <div>
            <label className="rbx-label" htmlFor="rbx-signin-password">Password</label>
            <input id="rbx-signin-password" className="rbx-input" type="password" value={password}
                   onChange={(e) => setPassword(e.target.value)} data-testid="rbx-signin-password"
                   autoComplete="current-password"/>
          </div>
          <div>
            <button type="submit" className="rbx-btn rbx-btn--primary"
                    disabled={status.state === "loading"} data-testid="rbx-signin-submit">
              {status.state === "loading" ? "Signing in…" : "Sign in"}
            </button>
          </div>
          {status.msg ? (
            <p className={`rbx-form__msg ${status.state === "ok" ? "rbx-form__msg--ok" : "rbx-form__msg--err"}`}
               data-testid="rbx-signin-msg">
              {status.msg}
            </p>
          ) : null}
        </form>
      </section>
    </RoboticsShell>
  );
}
